import accounts from "accounts/Accounts.js"
import Sample from "repos/Sample.js";

let cache = {};
export const getBulkSampleInfo = (ids, streamId) => {
    return new Promise(async (resolve) => {
        if (streamId in cache) {
            if (cache[streamId].lenggth === ids.length) {
                return resolve([... cache[streamId]]);
            }
        }
        fetch('/querySample/' , {
            method: 'POST',
            body: JSON.stringify({
                user: await accounts.getAccount(),
                ids: ids}),
            
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'appliction/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                let samples = [];
                if (!resp || !Array.isArray(resp)) {
                    cache[streamId] = samples;
                    return resolve(samples);
                }
                for (let data of resp) {
                    let sample = new Sample(data.id);
                    sample.name = data.title;
                    sample.packs = data.packs;
                    sample.videoId = data.videoId;
                    sample.favorited = data.rating === 5;
                    sample.blockNumber = data.blockNumber;
                    sample.sampledByUser = data.user;
                    sample.artistName = data.artistName;
                    sample.releaseName = data.releaseName;
                    sample.guildId = data.guildId;
                    sample.year = data.year;
                    sample.discogsId = data.discogsId;
                    sample.coverArtHash = data.coverArtHash === "" ? undefined : data.coverArtHash;
                    sample.tags = Array.from(new Set(data.tags || []));
                    samples.push(sample);
                }
                cache[streamId] = samples;
                resolve(samples);
            });
    });
};
